<template lang="html">
  <div>
    <b-jumbotron :header="title" :lead="lead" class="d-none d-lg-block">
      <!-- Only available lg and higher.-->
      <b-row>
        <b-col
          v-for="chord in heroChords"
          :key="chord"
          @click="$store.dispatch('toggleKnownChordAndUpdateResults', chord)"
        >
          <ChordDiagram
            :chord="chord"
            :fill-color="returnFillColor(chord)"
            :small="false"
          />
        </b-col>
        <b-col md="2">
          <b-btn
            :to="{
              name: 'chords',
              params: { tuning: $store.getters.ukeTuning }
            }"
            variant="outline-primary"
            size="sm"
            class="mt-5"
          >
            See more chords
          </b-btn>
        </b-col>
      </b-row>
      <p class="mt-4">
        UkeAbility links to play-along and tutorial videos from YouTube and
        other video hosting sites.
      </p>
    </b-jumbotron>
    <!-- Only available md and smaller.-->
    <div class="d-lg-none mb-4">
      <h1>{{ title }}</h1>
      <h2 class="lead">{{ lead }}</h2>

      <div class="d-none d-md-block d-lg-none">
        <b-row>
          <!-- Only available on md.-->
          <b-col
            v-for="chord in heroChords"
            :key="chord"
            md="2"
            @click="$store.dispatch('toggleKnownChordAndUpdateResults', chord)"
          >
            <ChordDiagram
              :chord="chord"
              :fill-color="returnFillColor(chord)"
              :small="false"
            />
          </b-col>
          <b-col>
            <b-btn
              :to="{
                name: 'chords',
                params: { tuning: $store.getters.ukeTuning }
              }"
              variant="outline-primary"
              size="sm"
              class="mt-3"
            >
              See more chords
            </b-btn>
          </b-col>
        </b-row>
      </div>

      <p class="d-md-none">
        <!-- Only available sm and smaller.-->
        <span
          v-for="chord in heroChords.slice(0, 4)"
          :key="chord"
          @click="$store.dispatch('toggleKnownChordAndUpdateResults', chord)"
        >
          <ChordDiagram
            :chord="chord"
            :fill-color="returnFillColor(chord)"
            :small="true"
          />
        </span>
      </p>
      <p class="mt-4 small">
        UkeAbility links to play-along and tutorial videos ... search with
        chords.
      </p>
    </div>
  </div>
</template>

<script>
import ChordDiagram from "@/components/ChordDiagram";
export default {
  name: "FrontHero",
  components: {
    ChordDiagram
  },
  data() {
    return {
      title: "🌴UkeAbility",
      lead:
        "Click the chords you know, and UkeAbility will show you songs that match your skills"
    };
  },
  computed: {
    heroChords() {
      return this.$store.state.hero_chords;
    }
  },
  methods: {
    returnFillColor(chordName) {
      if (this.$store.getters.knownChords.includes(chordName)) {
        return "green";
      }
      return "black";
    }
  }
};
</script>

<style lang="css" scoped>
p.lead{
  font-size: 1.5em;
  }
</style>
